import React from "react";
import Card from "./Card";
import Icon from "./Icon";
import Badge from "./Badge";
import Button from "./Button";

export function DocumentCard({
  document,
  categoryLabel,
  onView,
  onDownload,
  onReplace,
  onDelete,
  replacing = false,
  deleting = false,
}) {
  if (!document) return null;

  return (
    <Card className="doc-card">
      <div className="doc-meta">
        <div className="stack-inline">
          <Icon name="pdf" size={22} />
          <div className="doc-name">{document.name}</div>
        </div>
        <div className="muted">
          {document.size} | {document.date}
        </div>
        <div className="doc-badges">
          {categoryLabel ? <Badge variant="primary">{categoryLabel}</Badge> : null}
          {document.orgId ? <Badge variant="muted">{document.orgId}</Badge> : null}
          {Number.isFinite(document.totalChunks) ? (
            <Badge variant="success">{document.totalChunks} chunks</Badge>
          ) : null}
        </div>
      </div>

      {document.description ? (
        <div className="muted doc-description">{document.description}</div>
      ) : null}

      <div className="doc-actions">
        <Button
          variant="secondary"
          size="sm"
          iconLeft={<Icon name="view" size={16} />}
          onClick={() => onView?.(document)}
        >
          View
        </Button>
        <Button
          variant="secondary"
          size="sm"
          iconLeft={<Icon name="download" size={16} />}
          onClick={() => onDownload?.(document)}
        >
          Download
        </Button>
        <Button
          variant="secondary"
          size="sm"
          iconLeft={<Icon name="edit" size={16} />}
          onClick={() => onReplace?.(document)}
          loading={replacing}
        >
          Replace
        </Button>
        <button
          type="button"
          className="icon-action danger"
          aria-label="Delete document"
          onClick={() => onDelete?.(document)}
          disabled={deleting}
        >
          <Icon name="trash" size={16} />
        </button>
      </div>
    </Card>
  );
}

export default DocumentCard;
